import { Link } from "react-router-dom";
import { useState } from "react";

const ContestButton = ({ settings, contestId, contestName, contestImage, backgroundImage }) => {
  const [showSidebar, setShowSidebar] = useState(false);

  if (settings?.language === "ru") {
    return null;
  }

  const buttonStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url('${backgroundImage}')`
  };

  return (
    <Link
      onClick={() => setShowSidebar(false)}
      to={`../contests/${contestId}/`}
      className="btn btn-outline-success w-100 filter pinned-contest mb-2 d-flex justify-content-center align-items-center p-0"
      style={buttonStyle}
    >
      <div className="d-flex flex-column align-items-end">
        <img
          src={contestImage}
          style={{ height: "82px", filter: "drop-shadow(2px 4px 6px black)" }}
          alt="Contest Icon"
        />
      </div>
      <div className="text-center mx-0">Weekly Contest<br></br>
        {contestName}
      </div>
    </Link>
  );
};

export default ContestButton;